import { useRef, useCallback } from "react";
import { HEADER } from "@/components/Header/constants";
import { View, StyleSheet } from "react-native";
import { Button } from "@/components/ui/Button";
import { ThemedText } from "@/components/ThemedText";
import { useTheme } from "@/hooks/useTheme";
import { useToolTip } from "@/hooks/useToolTip";
import useContextMenu from "@/hooks/useContextMenu";
import { MaterialCommunityIcons } from "@expo/vector-icons";

export function NotificationsButton() {
  const { colors } = useTheme();
  const toolTip = useToolTip();
  const contextMenu = useContextMenu();
  const ref = useRef<View>(null);
  const isHovering = useRef(false);

  const handlePointerEnter = useCallback(() => {
    isHovering.current = true;
    toolTip.setToolTipContent(
      <View
        style={{
          backgroundColor: colors.background,
          paddingHorizontal: 8,
          paddingVertical: 4,
          borderRadius: 8,
          borderWidth: StyleSheet.hairlineWidth,
          borderColor: colors.border,
        }}
      >
        <ThemedText style={{ fontSize: 12 }}>Notifications</ThemedText>
      </View>,
    );
    ref.current?.measureInWindow((x, y, w, h) => {
      if (!isHovering.current) return;
      toolTip.setLocation({ x: x + (w || 0) / 2 - 50, y: y + (h || 0) + 4, width: 100, height: 30 } as any);
      toolTip.setVisible(true);
    });
  }, [colors.background, colors.border, toolTip]);

  const handlePointerLeave = useCallback(() => {
    isHovering.current = false;
    toolTip.setVisible(false);
  }, [toolTip]);

  const handlePress = useCallback(() => {
    toolTip.setVisible(false);
    if (contextMenu.visible) {
      contextMenu.setVisible(false);
      return;
    }
    ref.current?.measureInWindow((x, y, w, h) => {
      const menuWidth = 300;
      contextMenu.setLocation({ x: x + (w || 0) - menuWidth, y: y + (h || 0) + 4, width: menuWidth });
      contextMenu.setIgnoreRef(ref);
      contextMenu.setMenuContent(
        <View style={{ padding: 4 }}>
          <ThemedText style={{ paddingHorizontal: 8, paddingTop: 4, paddingBottom: 8, opacity: 0.5, fontSize: 12 }}>
            Notifications
          </ThemedText>
          <View style={{ alignItems: "center", paddingVertical: 24, gap: 8 }}>
            <MaterialCommunityIcons name="bell-check-outline" size={32} color={colors.textSecondary} />
            <ThemedText style={{ fontSize: 13, color: colors.textSecondary }}>You&apos;re all caught up</ThemedText>
          </View>
        </View>,
      );
      contextMenu.setVisible(true);
    });
  }, [contextMenu, toolTip, colors.textSecondary]);

  return (
    <View ref={ref} onPointerEnter={handlePointerEnter} onPointerLeave={handlePointerLeave}>
      <Button
        icon="bell-outline"
        onPress={handlePress}
        style={{ height: HEADER.ICON_SIZE, width: HEADER.ICON_SIZE }}
        iconSize={HEADER.ICON_PX}
      />
    </View>
  );
}
